module.exports = __webpack_public_path__ + "img/tutorial-f02-04.60556547.png";